import React, { useState, useEffect } from 'react';

const Lokasi = () => {
  const [settings, setSettings] = useState({
    address: 'Jl. Frans Seda No.21, Klp. Lima, Kec. Klp. Lima',
    phone: '0821-1751-9556',
    location_url: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3927.255531910833!2d123.60704337479588!3d-10.159872489953871!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2c569cb6f942a363%3A0x5d7910de639505a4!2sJl.%20Frans%20Seda%20No.21%2C%20Fatululi%2C%20Kec.%20Oebobo%2C%20Kota%20Kupang%2C%20Nusa%20Tenggara%20Tim.%2085111!5e0!3m2!1sid!2sid!4v1752326032638!5m2!1sid!2sid'
  });

  // Fetch settings dari API
  useEffect(() => {
    fetch('https://app.bimbelstemakupang.com/api/settings')
      .then((response) => response.json())
      .then((data) => {
        if (data) {
          setSettings({
            address: data.address || 'Jl. Frans Seda No.21, Klp. Lima, Kec. Klp. Lima',
            phone: data.phone || '0821-1751-9556',
            location_url: data.location_url || 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3927.255531910833!2d123.60704337479588!3d-10.159872489953871!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2c569cb6f942a363%3A0x5d7910de639505a4!2sJl.%20Frans%20Seda%20No.21%2C%20Fatululi%2C%20Kec.%20Oebobo%2C%20Kota%20Kupang%2C%20Nusa%20Tenggara%20Tim.%2085111!5e0!3m2!1sid!2sid!4v1752326032638!5m2!1sid!2sid'
          });
        }
      })
      .catch((error) => {
        console.error('Error fetching settings:', error);
      });
  }, []);

  return (
    <section id="location" className="lokasi-section">
      <div className="container">
        <div className="section-title text-center mb-5">
          <h2 style={{ 
            fontSize: '2.5rem', 
            fontWeight: 'bold', 
            marginBottom: '1rem',
            color: '#333'
          }}>
            Lokasi Kami
          </h2>
          <p style={{ 
            fontSize: '1.1rem', 
            color: '#666',
            maxWidth: '600px',
            margin: '0 auto'
          }}>
          </p>
        </div>
        
        <div className="row align-items-start">
          <div className="col-lg-7 mb-4">
            <div className="lokasi-maps" style={{ 
              height: '400px', 
              borderRadius: '15px', 
              overflow: 'hidden',
              boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
              border: '1px solid #e0e0e0'
            }}>
              <iframe
                src={settings.location_url}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Lokasi Bimbel"
              ></iframe>
            </div>
          </div>
          
          <div className="col-lg-5">
            <div className="lokasi-info" style={{
              backgroundColor: '#f8f9fa',
              padding: '2rem',
              borderRadius: '15px',
              height: '400px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              boxShadow: '0 5px 20px rgba(0,0,0,0.08)'
            }}>
              <h3 style={{ 
                color: '#1e40af', 
                marginBottom: '1.5rem',
                fontSize: '1.5rem',
                fontWeight: 'bold'
              }}>
                📍 Alamat Bimbel
              </h3>
              
              <div className="info-item mb-3">
                <div className="d-flex align-items-start">
                  <i className="bi bi-geo-alt-fill" style={{ 
                    color: '#dc3545', 
                    fontSize: '1.2rem',
                    marginRight: '10px',
                    marginTop: '2px'
                  }}></i>
                  <div>
                    <p style={{ 
                      margin: 0, 
                      fontSize: '1rem',
                      color: '#333',
                      lineHeight: '1.5'
                    }}>
                      {settings.address}
                    </p>
                    <p style={{ 
                      margin: '5px 0 0 0', 
                      fontSize: '1rem',
                      color: '#333'
                    }}>
                      Kota Kupang, Nusa Tenggara Tim. 85111
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="info-item mb-4">
                <div className="d-flex align-items-center">
                  <i className="bi bi-telephone-fill" style={{ 
                    color: '#28a745', 
                    fontSize: '1.2rem',
                    marginRight: '10px'
                  }}></i>
                  <p style={{ 
                    margin: 0, 
                    fontSize: '1rem',
                    color: '#333'
                  }}>
                    Telp: {settings.phone}
                  </p>
                </div>
              </div>
              
              <a 
                href="https://www.google.com/maps" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="btn-maps"
                style={{
                  display: 'inline-block',
                  backgroundColor: '#1e40af',
                  color: 'white',
                  padding: '12px 25px',
                  borderRadius: '25px',
                  textDecoration: 'none',
                  fontSize: '1rem',
                  fontWeight: '500',
                  transition: 'all 0.3s ease',
                  textAlign: 'center',
                  border: 'none',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = '#1e3a8a';
                  e.target.style.transform = 'translateY(-2px)';
                  e.target.style.boxShadow = '0 5px 15px rgba(30, 64, 175, 0.3)';
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = '#1e40af';
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = 'none';
                }}
              >
                <i className="bi bi-map me-2"></i>
                Buka di Google Maps
              </a>
            </div>
          </div>
        </div>
        
        {/* Additional Info Cards */}
        <div className="row mt-5">
          <div className="col-md-4 mb-3">
            <div className="info-card text-center p-4" style={{
              backgroundColor: 'white',
              borderRadius: '10px',
              boxShadow: '0 5px 15px rgba(0,0,0,0.08)',
              border: '1px solid #f0f0f0'
            }}>
              <i className="bi bi-clock-fill" style={{ 
                fontSize: '2rem', 
                color: '#ffc107',
                marginBottom: '1rem'
              }}></i>
              <h5 style={{ color: '#333', marginBottom: '0.5rem' }}>Jam Operasional</h5>
              <p style={{ color: '#666', margin: 0, fontSize: '0.9rem' }}>
                Senin - Jumat: 08:00 - 17:00<br/>
                Sabtu: 08:00 - 15:00
              </p>
            </div>
          </div>
          
          <div className="col-md-4 mb-3">
            <div className="info-card text-center p-4" style={{
              backgroundColor: 'white',
              borderRadius: '10px',
              boxShadow: '0 5px 15px rgba(0,0,0,0.08)',
              border: '1px solid #f0f0f0'
            }}>
              <i className="bi bi-car-front-fill" style={{ 
                fontSize: '2rem', 
                color: '#17a2b8',
                marginBottom: '1rem'
              }}></i>
              <h5 style={{ color: '#333', marginBottom: '0.5rem' }}>Akses Transportasi</h5>
              <p style={{ color: '#666', margin: 0, fontSize: '0.9rem' }}>
                Mudah dijangkau dengan<br/>
                kendaraan pribadi & umum
              </p>
            </div>
          </div>
          
          <div className="col-md-4 mb-3">
            <div className="info-card text-center p-4" style={{
              backgroundColor: 'white',
              borderRadius: '10px',
              boxShadow: '0 5px 15px rgba(0,0,0,0.08)',
              border: '1px solid #f0f0f0'
            }}>
              <i className="bi bi-wifi" style={{ 
                fontSize: '2rem', 
                color: '#28a745',
                marginBottom: '1rem'
              }}></i>
              <h5 style={{ color: '#333', marginBottom: '0.5rem' }}>Fasilitas Lengkap</h5>
              <p style={{ color: '#666', margin: 0, fontSize: '0.9rem' }}>
                WiFi gratis, AC, tempat parkir<br/>
                dan ruang belajar nyaman
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Lokasi;